/**
 * @generated SignedSource<<02651fbbff36a680e8395748036ab8c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type userCompleteApplicationVerificationMutation$variables = {
  userId: string;
};
export type userCompleteApplicationVerificationMutation$data = {
  readonly completeApplicationVerification: boolean;
};
export type userCompleteApplicationVerificationMutation = {
  variables: userCompleteApplicationVerificationMutation$variables;
  response: userCompleteApplicationVerificationMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "kind": "ScalarField",
    "name": "completeApplicationVerification",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "userCompleteApplicationVerificationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "userCompleteApplicationVerificationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "956af9eb659fd1c386b709118b7ab434",
    "id": null,
    "metadata": {},
    "name": "userCompleteApplicationVerificationMutation",
    "operationKind": "mutation",
    "text": "mutation userCompleteApplicationVerificationMutation(\n  $userId: ID!\n) {\n  completeApplicationVerification(userId: $userId)\n}\n"
  }
};
})();

(node as any).hash = "d16b24244f5c931bdb646115392fc7f4";

export default node;
